import { render, staticRenderFns } from "./DialogLogout.vue?vue&type=template&id=1f225597&lang=pug"
import script from "./DialogLogout.vue?vue&type=script&lang=js"
export * from "./DialogLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports